// import React from "react";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";

// interface ExcelExportButtonProps {
//     data: any[];
//     fileName: string;
// }

// const ExcelExportButton: React.FC<ExcelExportButtonProps> = ({ data, fileName }) => {
//     const formatDate = (date: string) => {
//         if (!date) return "-";
//         return new Date(date).toLocaleDateString("en-gb", {
//             day: "2-digit",
//             month: "short",
//             year: "numeric",
//         });
//     };

//     const exportToExcel = () => {
//         if (!data || data.length === 0) return;

//         const formattedData = data.map((row) => {
//             const newRow: any = { ...row };

//             Object.keys(newRow).forEach((key) => {
//                 if (key.toLowerCase().includes("date")) {
//                     newRow[key] = formatDate(newRow[key]);
//                 }
//             });

//             return newRow;
//         });

//         const ws = XLSX.utils.json_to_sheet(formattedData);
//         const wb = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

//         const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//         const blob = new Blob([wbout], { type: "application/octet-stream" });
//         saveAs(blob, `${fileName}.xlsx`);
//     };

//     return (
//         <div style={{ textAlign: "right", marginBottom: "0.5rem" }}>
//             <button
//                 type="button"
//                 className="p-button p-component p-button-success"
//                 onClick={exportToExcel}
//             >
//                 Export
//             </button>
//         </div>
//     );
// };

// export default ExcelExportButton;


import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

type TableType =
  | "ASSIGNED"
  | "DELIVERED"
  | "UNDELIVERED"
  | "DISTRIBUTION"
  | "CANCELLED"
  | null;

interface ExcelExportButtonProps {
    data: any[];
    fileName: string;
    tableType: TableType;
}

const ExcelExportButton: React.FC<ExcelExportButtonProps> = ({ 
    data, 
    fileName, 
    tableType 
}) => {
    const formatDate = (date: string) => {
        if (!date) return "-";
        return new Date(date).toLocaleDateString("en-gb", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };

    // Define which columns to exclude for each table type
    const getColumnsToExclude = (type: TableType): string[] => {
        switch (type) {
            case "CANCELLED":
                return ["deliveredBy", "deliveredDate"];
            case "UNDELIVERED":
                return ["deliveredBy", "deliveredDate"];
                case "DELIVERED":
            return ["delayedReason"];
            default:
                return [];
        }
    };

    // Filter object properties based on excluded columns
    const filterColumns = (obj: any, columnsToExclude: string[]): any => {
        const filtered: any = {};
        Object.keys(obj).forEach(key => {
            if (!columnsToExclude.includes(key)) {
                filtered[key] = obj[key];
            }
        });
        return filtered;
    };

    const exportToExcel = () => {
        if (!data || data.length === 0) return;

        const columnsToExclude = getColumnsToExclude(tableType);

        const formattedData = data.map((row) => {
            // Filter out unwanted columns first
            const filteredRow = filterColumns(row, columnsToExclude);

            // Format dates in the filtered row
            const newRow: any = { ...filteredRow };
            Object.keys(newRow).forEach((key) => {
                if (key.toLowerCase().includes("date")) {
                    newRow[key] = formatDate(newRow[key]);
                }
            });

            return newRow;
        });

        const ws = XLSX.utils.json_to_sheet(formattedData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const blob = new Blob([wbout], { type: "application/octet-stream" });
        saveAs(blob, `${fileName}.xlsx`);
    };

    return (
        <div style={{ textAlign: "right", marginBottom: "0.5rem" }}>
            <button
                type="button"
                className="p-button p-component p-button-success"
                onClick={exportToExcel}
            >
                Export
            </button>
        </div>
    );
};

export default ExcelExportButton;
